module.exports = __webpack_public_path__ + "static/media/tanakh.b8413f02.svg";